import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/AuthContext";
import { LoadingScreen } from "@/components/common/LoadingScreen";
import { ROUTES } from "@/constants/routes";

export function RiderRoute() {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === "loading") return <LoadingScreen label="Checking rider session…" />;
    if (status !== "authenticated" || !user) {
        return (
            <Navigate
                to={ROUTES.riderLogin}
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }
    if (user.role !== "rider") {
        // Strict role isolation — bounce to their correct portal, not home.
        const target =
            user.role === "customer"
                ? ROUTES.login
                : ROUTES.superAdminLogin;
        return <Navigate to={target} replace />;
    }
    return <Outlet />;
}

export default RiderRoute;
